fd.listings = {
    init: function() {
        var form = $("#listings-form");

        $("input[name=postcode]").postcode();
        $("#advanced-listings-search-btn")
            .click(function() {
                form.toggleClass("advanced-on");
                $(".fa", this).toggleClass("fa-search-plus fa-search-minus");

                if (form.hasClass("advanced-on")) {
                    form.append('<input type="hidden" name="advanced" value="on"/>');
                } else {
                    $("input[name=advanced]", form).remove();

                    $(".advanced-field select").each(function() {
                        $(this).val($("option:first", this).val());
                    });

                    $("input, textarea", ".advanced-field").each(function() {
                        $(this).val("");
                    });
                }

                return false;
            });
    }
}
